export class Course{
    UniqueId : string;
    Name:string
    Id:string
    Code:string;
    FullName : string;

}